import { Observable } from 'rxjs';

import { ChannelDenoiserLevel, Response } from '@shure/shared/angular/data-access/system-api/models';

import { DenoiserChannel } from '../models';

export abstract class DenoiserApiService {
	/**
	 * Get channel that supports denoiser.
	 */
	public abstract getChannel$(channelId: string): Observable<DenoiserChannel>;

	/**
	 * Enable/disable denoiser for channel.
	 */
	public abstract toggleDenoiser(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * Set denoiser level for channel.
	 */
	public abstract setDenoiserLevel(
		channelId: string,
		level: ChannelDenoiserLevel
	): Observable<Response<void, string>>;
}
